<template>
  <div class="col-sm-12 nopads">
    <div class="col-sm-12 editor-form" @click.stop="">
      <h2 class="editor-header">{{ userUpdate.id > 0 ? $t('users.edit_user') : $t('users.add_user') }}</h2>
      <div class="col-sm-12 form-data nopads">
        <span class="span-title required">
          {{ $t('users.user_name') }}
        </span>
          <div>
              <input
                  id="username"
                  v-model="userUpdate.username"
                  type="text"
                  :class="[
                      'form-control',
                      'form-control-sm',
                      usernameState === true ? 'is-valid' : '',
                      usernameState === false ? 'is-invalid' : ''
                    ]"
                  :disabled="userUpdate.id > 0"
              />
          </div>
        <div class="row">
            <div class="col-sm-6">
                <span class="span-title required">
                  {{ $t('users.first_name') }}
                </span>
                <input
                    id="first_name"
                    v-model="userUpdate.first_name"
                    type="text"
                    :class="[
                      'form-control',
                      'form-control-sm',
                      firstnameState === true ? 'is-valid' : '',
                      firstnameState === false ? 'is-invalid' : ''
                    ]"
                />
            </div>
            <div class="col-sm-6">
                <span class="span-title required">
                  {{ $t('users.last_name') }}
                </span>
                <input
                    id="last_name"
                    v-model="userUpdate.last_name"
                    type="text"
                    :class="[
                      'form-control',
                      'form-control-sm',
                      lastnameState === true ? 'is-valid' : '',
                      lastnameState === false ? 'is-invalid' : ''
                    ]"
                />

            </div>
        </div>

        <span
          class="span-title"
          :class="{ required: phoneMandatory }"
        >
          {{ $t('users.phone') }}
        </span>
          <input
              id="phone"
              v-model="userUpdate.phone"
              type="text"
              :class="[
                'form-control',
                'form-control-sm',
                phoneState === true ? 'is-valid' : '',
                phoneState === false ? 'is-invalid' : ''
              ]"
          />

        <div v-if="isAdmin" class="nopads">
          <span class="span-title">
            {{ $t('users.company') }}
          </span>
            <select
                id="customer"
                v-model="company"
                class="form-select form-select-sm mb-3"
            >
                <option :value="null" disabled>
                    {{ $t('users.select_company') }}
                </option>
                <option
                    v-for="c in companies"
                    :key="c.id"
                    :value="c.id"
                >
                    {{ c.name }}
                </option>
            </select>
        </div>
        <div v-if="isAdmin" class="nopads">
          <span class="span-title required">
            {{ $t('users.license_holder') }}
          </span>
            <select
                id="license"
                v-model="licenseHolder"
                class="form-select form-select-sm mb-3"
                :class="{ 'is-valid': licenseHolder !== null, 'is-invalid': licenseHolder === null }"
                :disabled="!companies || companies.length < 1"
            >
                <option :value="null" disabled>
                    {{ $t('users.select_company') }}
                </option>
                <option
                    v-for="c in companies"
                    :key="c.id"
                    :value="c.id"
                >
                    {{ c.name }}
                </option>
            </select>
        </div>

        <span class="span-title">
          {{ $t('users.tax_number') }}
        </span>
          <input
              id="tax_number"
              v-model="userUpdate.tax_number"
              type="text"
              class="form-control form-control-sm"
          />

        <span class="span-title required">
          {{ $t('users.email') }}
        </span>
          <input
              id="email"
              v-model="userUpdate.email"
              type="text"
              class="form-control form-control-sm"
              :class="{ 'is-valid': emailState === true, 'is-invalid': emailState === false }"
          />

        <span class="span-title">
          {{ $t('common.info') }}
        </span>
          <textarea
              id="info"
              v-model="userUpdate.info"
              class="form-control"
              :placeholder="$t('vehicle_editor.additional_info')"
              rows="2"
              style="resize: vertical;"
          ></textarea>

        <!-- New user rights -->
        <div class="col-sm-12">
          <span class="span-title">
            {{ $t('users.rights') }}
          </span>
          <user-rights-editor
            ref="userRights"
            :is-admin="isAdmin"
            :rights="userRights"
            :companies="companies"
            :roles="roles"
            @add-user-right="addUserRight"
            @remove-user-right="removeUserRight"
          />
        </div>
      </div>
      <div class="col-sm-12 button-container pb-3">
          <button
            class="btn btn-primary form-button"
            :disabled="!!loading || !userToEdit.id"
            @click.stop="reSendCredentialsEmail"
          >
              {{ $t('users.resend_credentials') }}
          </button>
        <button
          class="btn btn-primary form-button"
          :disabled="!!loading || userToEdit.id < 1"
          @click.stop="getResetLink"
        >
          {{ $t('users.reset_password') }}
        </button>
        <button
          class="btn btn-secondary form-button"
          @click.stop="$emit('close')"
        >
          {{ $t('common.cancel') }}
        </button>
        <button
          class="btn btn-success form-button"
          :disabled="formState"
          @click.stop="submit"
        >
          {{ $t('common.save') }}
        </button>
      </div>
    </div>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {userHelper} from '../mixins/UserMixin'
import UserRightsEditor from "./UserRightsEditor";
import {inject} from "vue";
import {toast} from "vue3-toastify";

export default {
    name: 'UserEditor',
    components: {UserRightsEditor},
    mixins: [userHelper, restApi],
    props: {
        user: {
            type: Object,
        },
        userToEdit: {
            type: Object,
            default: null
        },
        isAdmin: {
            type: Boolean,
            default: false
        },
        phoneMandatory: {
            type: Boolean,
            default: false
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data() {
        return {
            loading: 0,
            company: null,
            licenseHolder: null,
            companies: [],
            roles: [],
            userRights: [],
            resetLink: null,
            userUpdate: this.jsonToUser(this.userToEdit)
        }
    },
    computed: {
       phoneState() {
           if (this.phoneMandatory) {
               return (this.userUpdate.phone && this.userUpdate.phone.length > 4) ? true : false
           }
           return null
       },
       emailState() {
           return this.validEmail(this.userUpdate.email)
       },
       usernameState() {
           return !!(this.userUpdate.username && this.userUpdate.username.length > 2)
       },
       firstnameState() {
          return !!(this.userUpdate.first_name && this.userUpdate.first_name.length > 0)
       },
       lastnameState() {
          return !!(this.userUpdate.last_name && this.userUpdate.last_name.length > 1)
       },
       formState () {
           return !this.emailState || !this.usernameState || !this.firstnameState || !this.lastnameState || !!this.loading
       }
    },

    mounted() {
        this.fetchRoles()
        this.fetchCompanies()
        if (this.userUpdate.company) {
            this.company = this.userUpdate.company.id
            this.companies.push(this.userUpdate.company)
        }
        if (this.userToEdit.rights) {
            this.userRights = JSON.parse(JSON.stringify(this.userToEdit.rights))
        }
    },

    methods: {
        async fetchRoles() {
            this.loading++;
            const { err, ...response } = await this.axios.get(this.userRoleUrl).catch((err) => ({err}));
            this.loading--;
            if (err) {
                // Do something
                return;
            }
            this.roles = response.data;
        },

        async fetchCompanies() {
            this.loading++;
            const { err, ...response } = await this.axios.get(this.companyUrl).catch((err) => ({err}));
            this.loading--;
            if (err) {
                // Do something
                return;
            }
            this.companies = response.data;
            if (this.userUpdate.license_holder) {
                this.licenseHolder = this.userUpdate.license_holder.id
            }
        },

        async reSendCredentialsEmail() {
            this.restAdd(this.resendUserCredentials, {
                userId: this.userToEdit.id
            }, this.resendCredentialSuccess, this.resendCredentialsFail)
        },

        resendCredentialSuccess() {
            toast.success(this.$t('users.resend_credentials_success'), {
                autoClose: 5000,
                position: toast.POSITION.TOP_CENTER
            });

            this.$emit('closeAndUpdate')
        },

        resendCredentialsFail() {
            toast.error(this.$t('users.resend_credentials_fail'), {
                autoClose: 5000,
                position: toast.POSITION.TOP_CENTER
            });
        },

        setDefaultValues(user) {
            if (!user.username) {
                this.showAlert(this.$t('users.err_username'))
                return
            }
            if (!user.email) {
                this.showAlert(this.$t('users.err_email'))
                return
            }
            if (this.isAdmin) {
                if (this.licenseHolder) {
                    user.license_holder = this.companies.find(company => company.id === this.licenseHolder)
                    user.company = this.companies.find(company => company.id === this.company)
                } else {
                    this.showAlert(this.$t('users.err_select_license_holder'))
                    return
                }
            }
            else {
                user.company = this.userUpdate.company;
                user.license_holder = this.userUpdate.license_holder || this.userToEdit.company
            }
            user.roles = []
            // User rights
            user.rights = this.userRights
            return user
        },

        submit() {
            // set user right that was not added by plus button
            let userRight = this.$refs.userRights.$refs.selector.addUnAddedUserRight()
            if(userRight) {
                this.addUserRight(userRight)
            }
            this.submitUser()
        },

        submitUser() {
            var jsonUser = this.setDefaultValues(this.userUpdate)
            if (jsonUser === undefined) {
                return;
            }
            this.loading++;

            if (jsonUser.id < 1) {
                this.restAdd(this.userUrl, jsonUser, this.success, this.fail)
            } else {
                this.restUpdate(this.userUrl, jsonUser, this.success, this.fail)
            }
        },

        success () {
            this.loading--
            this.$emit('closeAndUpdate')
        },

        fail (response) {
            this.loading--
            if (response.status === 409) {
                this.showAlert(this.$t('common.alert_username_exists'));
            } else {
                this.showAlert(this.$t('common.alert_update_failed'));
            }
        },

        async addUserRight(userRight) {
            if (!this.isAdmin) {
                userRight.company = this.user.company;
            }
            if (!userRight.company || !userRight.role) {
                // Do something
                return;
            }
            // Check if role - company pair already exists and if not, add to user rights array
            if (this.userRights.find(
                (item) => item.company.id === userRight.company.id
                    && item.role.id === userRight.role.id
                    && !item.removed_at
            )) {
                // Do something
                return;
            }
            this.userRights.push(userRight);
            await this.$nextTick();
            this.$refs.userRights.reset();
        },

        removeUserRight(userRight) {
            if (userRight.id > 0) {
                // Exists in database - remove right properly
                const rightIndex = this.userRights.findIndex((right) => right.id === userRight.id);
                const right = this.userRights.splice(rightIndex, 1)[0];
                right.removed_at = new Date().toISOString();
                this.userRights.push(right);
            } else {
                // Not yet in database, just remove from list
                const index = this.userRights.findIndex(
                    (value) =>
                        value.role.id === userRight.role.id
                        && value.company.id === userRight.company.id
                        && !value.removed_at
                )
                this.userRights.splice(index, 1);
            }
        },

        async getResetLink() {
            this.resetLink = undefined
            this.loading++;
            const response = await this.axios.get(this.resetPasswordAdminUrl, { params: { user: this.userToEdit.id } });
            this.loading--;
            if (response && response.data) {
                this.resetLink = response.data.link
                if (this.resetLink) {
                    window.location.href = "mailto:" + this.userToEdit.email + "?subject=" + this.$t('users.reset_password') + "&body=" + this.resetLink;
                }
            }
        },

    }
}
</script>
